import { render, staticRenderFns } from "./app-personalise.vue?vue&type=template&id=1adc32b5&scoped=true&"
import script from "./app-personalise.vue?vue&type=script&lang=js&"
export * from "./app-personalise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc32b5",
  null
  
)

export default component.exports